import React, { useState, memo } from 'react';
import { TextField, IconPencilV3, IconCheck } from 'gatorcomponents';
import * as Styles from './ServerNickname.styles';

const ServerNickname = memo(({
  serverId,
  nickname,
  placeholder,
  onUpdateNickname,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState('');
  const hasNickName = Boolean(nickname);

  const handleEdit = () => {
    setIsEditing(true);
    setValue(nickname || '');
  };

  const handleConfirm = () => {
    if (value.length <= 20) {
      onUpdateNickname(serverId, value);
      setIsEditing(false);
      setValue('');
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value.slice(0, 20));
  };

  if (isEditing) {
    return (
      <Styles.NicknameEditContainer>
        <Styles.NicknameEditTextField>
          <TextField
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            label={null}
            inputHeight={46}
            maxLength={20}
            autoFocus
          />
        </Styles.NicknameEditTextField>
        <Styles.NicknameConfirmButton onClick={handleConfirm}>
          <IconCheck size="sm" color="highPure" />
        </Styles.NicknameConfirmButton>
      </Styles.NicknameEditContainer>
    );
  }

  return (
    <Styles.ServerNickName onClick={handleEdit} $hasNickname={hasNickName}>
      {nickname || placeholder}
      <IconPencilV3 size="sm" color="lowMedium" />
    </Styles.ServerNickName>
  );
});

ServerNickname.displayName = 'ServerNickname';

export default ServerNickname;
